import { NgModule } from '@angular/core';

import { IsSharedWithOthersPipe } from './is-shared-with-others.pipe';

@NgModule({
    imports: [],
    declarations: [IsSharedWithOthersPipe],
    exports: [IsSharedWithOthersPipe],
})
export class IsSharedWithOthersPipeModule {}
